module.exports = __webpack_public_path__ + "static/gradient_2-f35e0cba312d93c96e3673157e02c4ad.png";